import React from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';

const VendorForm = ({ handleChange, vendorForm, handleSubmit, handleCancel }) => {

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>
              Code<span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="code"
              value={vendorForm.code}
              onChange={handleChange}
              required
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Vendor Name <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={vendorForm.name}
              onChange={handleChange}
              required
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Location<span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              name="location"
              value={vendorForm.location}
              onChange={handleChange}
              required
            />
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Contact<span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              name="contact_number"
              value={vendorForm.contact_number}
              onChange={handleChange}
              required
            />
          </Form.Group>
        </Col>
      </Row>
      <div className="d-flex justify-content-end gap-2">
        <Button variant="secondary" onClick={handleCancel}>
          Cancel
        </Button>
        <Button type="submit" variant="primary">
          {vendorForm.id ? 'Update' : 'Add'}
        </Button>
      </div>
    </Form>
  );
};

export default VendorForm;